import { render } from "./DashboardLoginView.vue?vue&type=template&id=0a61988c&scoped=true"
import script from "./DashboardLoginView.vue?vue&type=script&lang=js"
export * from "./DashboardLoginView.vue?vue&type=script&lang=js"

import "./DashboardLoginView.vue?vue&type=style&index=0&id=0a61988c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a61988c"]])

export default __exports__